export const MAX_WALK_TIME_OPTIONS = [5,10,15,20,30,45,60]